import React from "react";
import PropTypes from "prop-types";

import { icons } from "assets";
import styles from "./transactions.module.css";
import Text from "../text";
import Button from "../button";

/**
 *
 * @param {object} action This represent the everything that needs to be passed to a button
 * @param {string | JSX.Element} action.label This represent the text that needs to be displayed on the button
 * @param {JSX.Element} graphics This represent the graphics that need to be displayed for the empty component
 * @param {string} className This represent the className that needs to be applied to the component
 * @param {string} title This represent the title for the empty component
 * @param {string} description This represent the description for the empty component
 * @returns
 */
const EmptyComponent = ({
  action,
  graphics,
  title,
  description,
  className,
  ...props
}) => {
  return (
    <div className={`${styles.EmptyComponent} ${className || ""}`} {...props}>
      {graphics && (
        <div className={styles.EmptyComponent_graphics}>{graphics}</div>
      )}
      {title && (
        <Text style={{ fontWeight: "700" }} variant="lg">
          {title}
        </Text>
      )}
      {description && (
        <Text variant="sm" color="secondary">
          {description}
        </Text>
      )}
      {action && (
        <Button
          style={{ marginTop: "24px" }}
          className={styles.EmptyComponent_action}
          {...action}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

EmptyComponent.propTypes = {
  action: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
      .isRequired,
    onClick: PropTypes.func,
  }),
  graphics: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};
export default EmptyComponent;
